import { FC } from "react";
import Image from "next/image";

const WrittenBy: FC<{
    author: string;
    className?: string;
    borderAvatar?: string;
    avatar?: string;
}> = ({ author, className, borderAvatar, avatar }) => {
    return (
        <div className={`d-flex align-items-center ${className}`}>
            <span>written by</span>
            <span className="ms-2">
                {avatar && (
                    <Image
                        src={avatar || ""}
                        style={{
                            borderColor: borderAvatar || "#00ff2a",
                            borderRadius: "50%",
                            objectFit: "cover",
                            border: "2px solid",
                        }}
                        alt="user-image"
                        width={40}
                        height={40}
                        quality={60}
                        loading="lazy"
                    />
                )}
            </span>
            <span>{author}</span>
        </div>
    );
};

export default WrittenBy;
